<template>
  <JdsLink
    type="button"
    @click="toggleText"
    className="sm:fe-text-body-xxs-link lg:fe-text-body-xs-link"
  >
    {{ isExpanded ? "Read less" : "Read more" }}
  </JdsLink>
</template>

<script>
  import JdsLink from "@/components/DesignSystem/JdsLink/JdsLink.vue"

  export default {
    name: "ReadMoreLess",
    components: { JdsLink },
    props: {
      isExpanded: {
        type: Boolean,
        required: true,
      },
    },
    methods: {
      toggleText() {
        this.$emit("toggle")
      },
    },
  }
</script>
